<template>
  <v-card class="elevation-0 mx-8 pa-2">
    <v-row class="ma-0">
        <v-select v-if="mealPlansList!=undefined" class="mx-2 mt-6" outlined v-model="selected_meal_plan" :items="mealPlansList" item-value="id" item-text="name" label="Plan Alimenticio" ></v-select>
        <v-btn class="my-8 ml-4 mr-6" v-if="selected_meal_plan!=undefined" icon target="_blank" :href="pdf(selected_meal_plan)">
            <v-icon color="white">mdi-download</v-icon>
        </v-btn>
    </v-row>

    <v-row class="ma-0">
        <v-col cols="4" class="pb-0">
            <v-text-field label="Titulo" v-model="meal_plan.name" outlined></v-text-field>
        </v-col>
         <v-col cols="4" class="pb-0">
            <v-text-field type="number" label="Kilocalorias Prescritas" v-model="calc.kilocalorias" outlined suffix="kilocalorias"></v-text-field>
        </v-col>
        <v-col cols="4" class="pb-0">
            <v-text-field type="number" label="Masa Magra Paciente" v-model="calc.lean_mass_kg" outlined suffix="kgs"></v-text-field>
        </v-col>
        
    </v-row>
    <v-row class="ma-0">
        <v-col cols="4" class="pb-0">
            <v-select :items="orders" label="Calcular Macros" v-model="calc.order[0].what" outlined suffix="gramos"></v-select>
        </v-col>
        <v-col cols="4" class="pb-0">
            <v-select :items="orders" label="Calcular porcentaje" v-model="calc.order[1].what" outlined suffix="%"></v-select>
        </v-col>
        <v-col cols="4" class="pb-0">
            <v-select :items="orders" label="Calculadora automatica" v-model="calc.order[2].what" outlined suffix="%"></v-select>
        </v-col>
    </v-row>
    <v-row class="ma-0">
        <v-col cols="4" class="pb-0">
            <v-text-field :label="calc.order[0].what" v-model="calc.order[0].value" outlined suffix="gramos"></v-text-field>
        </v-col>
        <v-col cols="4" class="pb-0">
            <v-text-field :label="calc.order[1].what" v-model="calc.order[1].value" outlined suffix="%"></v-text-field>
        </v-col>
        <v-col cols="4" class="pb-0">
            <v-text-field :label="calc.order[2].what" v-model="calc.order[2].value" outlined suffix="%"></v-text-field>
        </v-col>
    </v-row>
    <v-row class="ma-0">
        <v-btn class="elevation-0" block @click="calcNow()" dark color="#e12826">Calcular</v-btn>
    </v-row>
    <v-row class="ma-0">
        <v-col cols="4" class="py-0" v-for="(c, index) in calc.order" :key="index">
            <v-card style="text-align:center;" class="py-2 mt-2 elevation-0" dark>
                <v-card-subtitle class="py-0" style="color:white!important; font-weight:600;">
                    /{{ (calc[c.what+'_grams']*1).toFixed(2) + ' gramos'}}</v-card-subtitle>
                <v-card-subtitle class="py-0" style="color:white!important; font-weight:600;">
                    /{{ (calc[c.what]*1).toFixed(2) + '%'}}
                </v-card-subtitle>
                <v-card-subtitle class="py-0" style="filter:opacity(0.8); font-weight:600;">
                    /{{ (calc.kilocalorias*calc[c.what]/100).toFixed(2) + ' Kcal'}}
                </v-card-subtitle>
            </v-card>
        </v-col>
    </v-row>

    <v-row class="mx-0 my-4">
        <v-col class="pa-0" cols="2">
            <div class="my-6">
                <v-card class="elevation-0 pb-3 px-3 ma-1" style="font-weight:600; color:white;">
                    <v-btn @click="dialog=true" icon>
                        <v-icon> mdi-notebook-edit-outline </v-icon>
                    </v-btn>
                </v-card>
                <v-card class="pa-4 mx-1 mb-4" style="height:320px;" v-for="(meal_plan_time, index0) in meal_plan.options[0].times" :key="index0">
                    <v-row class="ma-0">
                        <v-text-field label="Etiqueta" dense v-model="times[index0].label" outlined></v-text-field>
                        <v-text-field label="Hora" dense v-model="times[index0].hour" outlined></v-text-field>
                    </v-row>
                    <v-text-field label="Porcentaje" suffix="%" dense v-model="times[index0].percentage" outlined></v-text-field>
                    <v-row class="mx-2 mt-2 mb-3">
                        <percentages :detail="false" :calc="calc" :time="times[index0]" :meal_plan_time="meal_plan_time" type="hc"/>
                    </v-row>
                    <v-row class="mx-2 mb-3">
                        <percentages :detail="false" :calc="calc" :time="times[index0]" :meal_plan_time="meal_plan_time" type="ps"/>
                    </v-row>
                    <v-row class="mx-2 mb-3">
                        <percentages :detail="false" :calc="calc" :time="times[index0]" :meal_plan_time="meal_plan_time" type="lp"/>
                    </v-row>
                    <v-row class="ma-0 pt-2" v-if="meal_plan.options[0].times.length>1">
                        <v-spacer/>
                        <v-icon small @click="removeFila(index0)">mdi-trash-can-outline</v-icon>
                        <v-spacer/>
                    </v-row>
                </v-card>
                <v-row class="ma-0" style="height: 100%;">
                    <v-btn style="margin:auto;" color="#e12826" dark fab class="elevation-0" x-small @click="calc.times=calc.times+1">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-row>
            </div>
        </v-col>
        <v-col class="pa-0" cols="9">
            <vue-horizontal scroll class="ma-6">
                <v-col class="pa-0 ma-0" cols="5" v-for="(meal_plan_option, index) in meal_plan.options" :key="index">
                    <v-card color="#e12826" class="py-1 px-3 ma-1" dark style="font-weight:600;">
                        <v-row class="ma-0">
                          Opción #{{index+1}}
                          <v-spacer/>
                          <!-- Totales del día -->
                          <span>
                            Día: {{ dailyStats(meal_plan_option).kcal.toFixed(2) }} Kcal ·
                            hc {{ dailyStats(meal_plan_option).hc_g.toFixed(2) }} g ·
                            ps {{ dailyStats(meal_plan_option).ps_g.toFixed(2) }} g ·
                            lp {{ dailyStats(meal_plan_option).lp_g.toFixed(2) }} g
                          </span>
                          <v-icon class="mr-2" small @click="duplicateOption(index, meal_plan_option)"> mdi-content-copy</v-icon>
                          <v-icon small @click="remove(index)">mdi-trash-can-outline</v-icon>
                        </v-row>
                    </v-card>

                    <v-dialog v-model="meal_plan_time.dialog" v-for="(meal_plan_time, index2) in meal_plan_option.times" :key="index2" width="1200" >
                        <template v-slot:activator="{ on, attrs }">
                            <v-card class="mx-1 mt-3 mb-4" style="height:340px;">
                                <v-row class="ma-0 pa-2" style="font-weight:600;">
                                  <!-- Totales por comida -->
                                  <div>
                                    Kcal: {{ timeStats(meal_plan_time).kcal.toFixed(2) }} ·
                                    hc {{ timeStats(meal_plan_time).hc_g.toFixed(2) }} g ·
                                    ps {{ timeStats(meal_plan_time).ps_g.toFixed(2) }} g ·
                                    lp {{ timeStats(meal_plan_time).lp_g.toFixed(2) }} g
                                  </div>
                                  <v-spacer/>
                                  <v-icon class="ma-0" small v-bind="attrs" v-on="on"> mdi-arrow-expand </v-icon>
                                </v-row>
                                <opc :show_detail="false" style="max-height:255px; overflow-y:scroll;" class="pt-1" :meal_plan_time="meal_plan_time" :meal_plan_option="meal_plan_option" :index="index" :index2="index2"/>
                            </v-card>
                        </template>
                        <v-card class="pa-2">
                            <v-row class="ma-0 pt-4 px-6">
                                <v-card dark class="px-4 py-2" style="width:30%;">
                                    <percentages :detail="true" :time="times[index2]" :calc="calc" :meal_plan_time="meal_plan_time" type="hc"/>
                                </v-card>
                                <v-card dark class="px-4 py-2" style="width:30%; margin:0px 5%;">
                                    <percentages :detail="true" :time="times[index2]" :calc="calc" :meal_plan_time="meal_plan_time" type="ps"/>
                                </v-card>
                                <v-card dark class="px-4 py-2" style="width:30%;">
                                    <percentages :detail="true" :time="times[index2]" :calc="calc" :meal_plan_time="meal_plan_time" type="lp"/>
                                </v-card>
                            </v-row>
                            <opc class="pa-4" :show_detail="true" :meal_plan_time="meal_plan_time" :meal_plan_option="meal_plan_option" :index="index" :index2="index2"/>
                        </v-card>
                    </v-dialog>
                </v-col>
            </vue-horizontal>
        </v-col>    
        <v-col cols="1">
            <v-row class="ma-0" style="height: 100%;">
                <v-btn style="margin:auto;" color="#e12826" dark fab class="elevation-0" x-small @click="addMenu()">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
    
    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
    <v-dialog v-model="dialog" width="600">
        <v-card class="pa-6">
            <v-card-title class="ma-0 pa-0 mb-2">Nota</v-card-title>
            <v-textarea outlined v-model="meal_plan.note"></v-textarea>
        </v-card>
    </v-dialog>
    <v-btn :loading="gris" v-if="this.selected_meal_plan!=undefined" @click="save('modify')" bottom color="black" dark fab fixed right style="transform:translateY(-70px)!important;">
        <v-icon color="white">  mdi-content-save-edit-outline </v-icon>
    </v-btn> 
    <v-btn :loading="gris" :disabled="gris" @click="save('create')" bottom color="#e12826" dark fab fixed right>
        <v-icon color="white">  mdi-content-save-outline </v-icon>
    </v-btn> 
  </v-card>
</template>

<script>
import axios from "axios"
import VueHorizontal from 'vue-horizontal';
import opc from "../diet/opc.vue"
import percentages from "../diet/percentages.vue"
export default {
    components: {
        VueHorizontal,
        opc:opc,
        percentages:percentages
    },
    data(){
        return{
            mealPlansList:undefined,
            selected_meal_plan:undefined,
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            gris:false,
            dialog:false,
            meal_plan:{
                name:'',
                user_id:this.$route.params.id,
                options:[{
                    times:[{
                        dialog:false,
                        foods:[{
                            food:'',
                            quantity:0
                        }],
                        food_dish:''
                    }]
                }],
                note:''
            },
            times:[{
                label:'',
                hour:'',
                percentage:0,
                l_percentage:0,
                p_percentage:0,
                h_percentage:0,
            }],
            calc:{
                kilocalorias:0,
                hc:0,
                ps:0,
                lp:0,
                times:1,
                hc_grams:0,
                ps_grams:0,
                lp_grams:0,
                hc_macros:0,
                ps_macros:0,
                lp_macros:0,
                lean_mass_kg:0,
                order:[
                    {
                        value:'', 
                        what:''
                    },
                    {
                        value:'', 
                        what:''
                    },
                    {
                        value:'', 
                        what:''
                    }
                ]
            },
            orders:['hc', 'ps', 'lp']
        }
    },
    computed:{
        isDirty(){
            function isNotNullUndefinedOrEmpty(value) {
                return value !== null && value !== undefined && value !== '' && value !== 0;
            }
            for (let key in this.meal_plan) {
                if(key!='user_id'&&key!='options'){
                    const value = this.meal_plan[key];
                    if (isNotNullUndefinedOrEmpty(value)) {
                        return true
                    }
                }else{
                    if(this.meal_plan.options.length>1 || this.meal_plan.options[0].times.length>1){
                        return true
                    }else{
                        for (let key2 in this.meal_plan.options[0].times[0]) {
                            if(key2!='dialog'&&key2!='foods'){
                                const value = this.meal_plan.options[0].times[0][key2];
                                if (isNotNullUndefinedOrEmpty(value)) {
                                    return true
                                }
                            }else if(key2=='foods'){
                                if(this.meal_plan.options[0].times[0].foods.length>1){
                                    return true
                                }else{
                                    for (let key3 in this.meal_plan.options[0].times[0].foods[0]) {
                                        const value = this.meal_plan.options[0].times[0].foods[0][key3];
                                        if (isNotNullUndefinedOrEmpty(value)) {
                                            return true
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            for (let llave in this.calc) {
                if(llave!='order'&&llave!='times'){
                    const value = this.calc[llave];
                    if (isNotNullUndefinedOrEmpty(value)) {
                        return true
                    }
                }else if(llave=='order'){
                    for (var i=0; i<this.calc.order; i++) {
                        for (let llave2 in this.calc.order[i]) {
                            const value = this.calc.order[i][llave2];
                            if (isNotNullUndefinedOrEmpty(value)) {
                                return true
                            }
                        }
                    }
                }else if(llave=='times'&&this.calc.times>1){
                    return true
                }
            }

            
        },
        calcTimes(){
            return this.calc.times
        }
    },
    methods:{
        // === Helpers kcal y gramos ===
        gramsFromItem(item){
            const q = Number(item.quantity) || 0
            return {
              c: (Number(item.food?.carbohydrates) || 0) * q,
              p: (Number(item.food?.protein)       || 0) * q,
              l: (Number(item.food?.lipids)        || 0) * q
            }
        },
        kcalFromMacros(item){
            const {c,p,l} = this.gramsFromItem(item)
            return c * 4 + p * 4 + l * 9
        },
        kcalDisplay(item){
            const k = this.kcalFromMacros(item)
            if (k > 0) return k
            return (Number(item.food?.energy) || 0) * (Number(item.quantity) || 0)
        },

        // === Stats por comida (time): hc/ps/lp en gramos + Kcal ===
        timeStats(meal_plan_time){
            const res = { hc_g:0, ps_g:0, lp_g:0, kcal:0 }
            if (!meal_plan_time || !Array.isArray(meal_plan_time.foods)) return res
            meal_plan_time.foods.forEach(item=>{
                const g = this.gramsFromItem(item)
                res.hc_g += g.c
                res.ps_g += g.p
                res.lp_g += g.l
                const kcal = this.kcalFromMacros(item)
                res.kcal += (kcal > 0 ? kcal : (Number(item.food?.energy)||0) * (Number(item.quantity)||0))
            })
            return res
        },

        // === TOTAL por tiempo (string formateado, retrocompatibilidad) ===
        calories(meal_plan_time) {
            return this.timeStats(meal_plan_time).kcal.toFixed(2)
        },

        // === Stats del día (opción) sumando sus times ===
        dailyStats(meal_plan_option){
            const acc = { hc_g:0, ps_g:0, lp_g:0, kcal:0 }
            if (!meal_plan_option || !Array.isArray(meal_plan_option.times)) return acc
            meal_plan_option.times.forEach(t=>{
                const s = this.timeStats(t)
                acc.hc_g += s.hc_g
                acc.ps_g += s.ps_g
                acc.lp_g += s.lp_g
                acc.kcal += s.kcal
            })
            return acc
        },

        pdf(id){
            return process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/export-pdf/' + id
        },
        
        calcNow () {
            const KCAL_PER_G = { hc: 4, ps: 4, lp: 9 };

            // Sanitizar entradas
            const kcalTotal   = Number(this.calc.kilocalorias)   || 0;
            const leanMassKg  = Number(this.calc.lean_mass_kg)   || 0;

            const first       = this.calc.order[0].what;           // 'lp' | 'ps' | 'hc'
            const second      = this.calc.order[1].what;
            const third       = this.calc.order[2].what;

            // 1) Primer macro: g/kg (viene del form en order[0].value)
            const first_g_per_kg = Number(this.calc.order[0].value) || 0;
            const first_grams    = leanMassKg * first_g_per_kg;
            const first_kcal     = first_grams * KCAL_PER_G[first];
            const first_pct      = kcalTotal > 0 ? (first_kcal * 100) / kcalTotal : 0;

            this.calc[first + '_macros'] = first_g_per_kg;  // guarda por si lo muestras
            this.calc[first + '_grams']  = first_grams;
            this.calc[first]             = first_pct;

            // 2) Segundo macro: porcentaje directo del form
            const second_pct = Math.max(0, Math.min(100, Number(this.calc.order[1].value) || 0));
            this.calc[second] = second_pct;

            // 3) Tercer macro: el resto
            let third_pct = 100 - first_pct - second_pct;
            if (!isFinite(third_pct)) third_pct = 0;
            third_pct = Math.max(0, third_pct);
            this.calc[third] = third_pct;

            // 4) Pasar % a gramos para segundo y tercero
            [second, third].forEach(macro => {
                const kcal = (kcalTotal * (Number(this.calc[macro]) || 0)) / 100;
                this.calc[macro + '_grams'] = KCAL_PER_G[macro] > 0 ? (kcal / KCAL_PER_G[macro]) : 0;
            });
        },


        save(action){
            const meal_plan = {
                name:this.meal_plan.name,
                user_id:this.$route.params.id,
                json: {
                    meal_plan:this.meal_plan.options,
                    calc:this.calc,
                    times:this.times
                },
                note:this.meal_plan.note
            }
            this.gris = true

            if(action == 'create'){
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/meal_plans",Object.assign(meal_plan)).then(response=>{
                    this.snackbar = {
                        message: 'Plan generado con éxito',
                        color: 'success',
                        show: true
                    }
                    this.gris = false
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'error',
                        show: true
                    }
                    this.gris = false
                })
            }else if(action == 'modify'){
                axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/meal_plans/"+this.meal_plan.id,Object.assign(meal_plan)).then(response=>{
                    this.snackbar = {
                        message: 'Plan modificado con éxito',
                        color: 'success',
                        show: true
                    }
                    this.gris = false
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'error',
                        show: true
                    }
                    this.gris = false
                })
            }
        },
        addMenu(){
            this.meal_plan.options.push({
                times:[{
                    dialog:false,
                    foods:[{
                        food:'',
                        quantity:''
                    }],
                    food_dish:''
                }]
            })
            this.checkTimes()
        },
        duplicateOption(index, option) {
            const copy = JSON.parse(JSON.stringify(option)) // clon profundo
            this.meal_plan.options.splice(index + 1, 0, copy)
        },
        remove(index){
            this.meal_plan.options.splice(index, 1)
        },
        removeFila(index){
            for(var x=0; x<this.meal_plan.options.length; x++){
                this.meal_plan.options[x].times.splice(index, 1)
            } 
        },
        checkTimes(){
            for(var i=0; i<this.meal_plan.options.length; i++){
                for(var j=0; j<this.meal_plan.options[i].times.length; j++){
                    if(this.meal_plan.options[i].times.length>this.calc.times){
                        this.meal_plan.options[i].times.slice(0,this.calc.times-1)
                    }else if(this.meal_plan.options[i].times.length<this.calc.times){
                        for(var x=0; x<(this.calc.times-this.meal_plan.options[i].times.length); x++){
                            this.meal_plan.options[i].times.push({
                                dialog:false,
                                foods:[{
                                    food:'',
                                    quantity:''
                                }],
                                food_dish:'',
                            })
                        }
                    }
                }
            }
        },
        getPlans () {
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/meal_plans?itemsPerPage=999&filter[user.id]=" + this.$route.params.id).then(response => {
                this.mealPlansList = response.data.data
            })
        }
    },
    created(){
        this.getPlans()
    },
    mounted(){
        this.getPlans()
    },
    watch:{
        '$route.params.id':{
            handler(){
                this.selected_meal_plan = undefined
                this.meal_plan = {
                    name:'',
                    user_id:this.$route.params.id,
                    options:[{
                        times:[{
                            dialog:false,
                            foods:[{
                                food:'',
                                quantity:0
                            }],
                            food_dish:''
                        }]
                    }],
                    note:''
                }
                this.times = [{
                    label:'',
                    hour:'',
                    percentage:0,
                }]
                this.calc = {
                    kilocalorias:0,
                    hc:0,
                    ps:0,
                    lp:0,
                    times:1,
                    hc_grams:0,
                    ps_grams:0,
                    lp_grams:0,
                    hc_macros:0,
                    ps_macros:0,
                    lp_macros:0,
                    lean_mass_kg:0,
                    order:[
                        {
                            value:'', 
                            what:''
                        },
                        {
                            value:'', 
                            what:''
                        },
                        {
                            value:'', 
                            what:''
                        }
                    ]
                }
                this.getPlans()
            }, deep:true
        },
        isDirty:{
            handler(){
                if(this.isDirty){
                    localStorage.setItem('isDirty', true)
                }
            }, deep:true
        },
        selected_meal_plan:{
            handler(){
                const plan = this.mealPlansList.filter(plan=>plan.id == this.selected_meal_plan)[0]
                this.meal_plan = {
                    name: plan.name,
                    options: plan.json.meal_plan,
                    user_id: plan.user.id,
                    id:plan.id
                }
                this.calc = plan.json.calc
                this.times = plan.json.times
                this.meal_plan.note = plan.note
            }, deep:true
        },
        calcTimes:{
            handler(){
                this.checkTimes()
                this.times.push({
                    label:'',
                    hour:'',
                    percentage:0
                })
            }, deep: true
        }
    }
}
</script>

<style>
.v-label {
    font-size: 12px!important;
}
.cantidades .v-text-field__suffix{
    font-size: 10px;
    margin-bottom: -38px;
    background: white;
    padding-right: 5px;
    position: absolute;
    right: -5px;
}
</style>
